import { render } from "./Sportsbook.vue?vue&type=template&id=24db7502&scoped=true"
import script from "./Sportsbook.vue?vue&type=script&lang=js"
export * from "./Sportsbook.vue?vue&type=script&lang=js"

import "./Sportsbook.vue?vue&type=style&index=0&id=24db7502&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-24db7502"

export default script